import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BankAccount } from '../../../banking/models/bank-account';

@Component({
  selector: 'app-review-deposit-details-deposit-card',
  templateUrl: './review-deposit-details-deposit-card.component.html',
  styleUrls: ['./review-deposit-details-deposit-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewDepositDetailsDepositCardComponent {
  @Input() bankAccount: BankAccount | null = null;
  @Input() isWrittenCheque = false;
}
